import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=6216c5db&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216c5db",
  null
  
)

export default component.exports